// extracted by mini-css-extract-plugin
export default {"pagination":"_3T5U-RtFuo","item":"_2_rEUBVMDu","link":"c0cXpZKWgl","item-navigation-next":"eNCgaYyVh_","itemNavigationNext":"eNCgaYyVh_","item-navigation-prev":"_2rvXuPmvuQ","itemNavigationPrev":"_2rvXuPmvuQ","item-disabled":"_1tpR301eKu","itemDisabled":"_1tpR301eKu","item-active":"M4Tjqm8KQJ","itemActive":"M4Tjqm8KQJ","item-break":"_3Bp17TvaMf","itemBreak":"_3Bp17TvaMf"};
    if(module.hot) {
      // 1628247948805
      var cssReload = require("!../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  